import { Fragment, ReactElement } from 'react';
import PersonMarriageNonResidentNotificationsCivilStatusShared from 'shell/components/shared/research-notifications-civil-status-registry-office/research-marriage-non-resident/edit-person';

const PersonMarriageNonResidentNotificationsCivilStatusPage = (): ReactElement => {
  return (
    <Fragment>
      <PersonMarriageNonResidentNotificationsCivilStatusShared />
    </Fragment>
  );
};

PersonMarriageNonResidentNotificationsCivilStatusPage.displayName =
  'Research Marriage Non Resident Notifications CivilStatusPage component';

export default PersonMarriageNonResidentNotificationsCivilStatusPage;
